import React from "react";
import ConstructionIcon from "@mui/icons-material/Construction";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import HomeIcon from "@mui/icons-material/Home";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ApprovalIcon from "@mui/icons-material/Approval";
import PersonIcon from "@mui/icons-material/Person";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import TuneIcon from "@mui/icons-material/Tune";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { isBottlerAdminEnabled } from "../utils/featureFlags";
import { SOP_KO_BOTTLER_ADMIN_ROLE } from "../utils/userAccess";

export const SIDEBAR_MENU = [
  {
    id: "sp",
    name: "Supply Planning",
    icon: <ConstructionIcon />,
    rules: [
      { name: "Consolidated Rule Level", path: "/supply-planning/ruleLevel" },
      { name: "Consolidated Material Level", path: "/supply-planning/materialLevel" },
      { name: "IBP Landing Page", path: "/supply-planning/IBPLandingPage" },
      { name: "IBP Home", path: "/supply-planning/IBPHomePage" },
    ],
  },
  {
    id: "io",
    name: "Inventory Optimization",
    icon: <Inventory2Icon />,
    path: "/inventory-optimization",
    rules: [],
  },
  {
    id: "kpi",
    name: "KPI Metrics",
    icon: <AssessmentIcon />,
    path: "/kpi-metrics",
    rules: [],
  },
  {
    id: "user",
    name: "User Access",
    icon: <SupervisorAccountIcon />,
    rules: [
      { name: "New Request", path: "/user-roles/new-request" },
      { name: "Track Request", path: "/user-roles/track-access-request" },
      { name: "Reports", path: "/user-roles/reports" },
      { name: "Approval Rights", path: "/user-roles/approval-rights" },
      { name: "Ticket Summary", path: "/user-roles/ticket-summary" },
      { name: "Approver Configuration", path: "/user-roles/admin-portal" },
      { name: "Admin Portal", path: "/user-roles/access-control" },
    ],
  },
];

export const USER_ACCESS_MENU = [
  { id: "home", name: "Home", icon: <HomeIcon />, path: "/", disabled: false },
  { id: "new-request", name: "New Request", icon: <NoteAddIcon />, path: "/user-roles/new-request", disabled: false },
  { id: "request-status", name: "Request Status", icon: <TrackChangesIcon />, path: "/user-roles/track-access-request", disabled: false },
  { id: "report", name: "Report", icon: <AssessmentIcon />, path: "/user-roles/reports", disabled: false, adminOnly: true },
  { id: "approval-delegation", name: "Approval Delegation", icon: <ApprovalIcon />, path: "/user-roles/approval-rights", disabled: false },
  { id: "ticket-summary", name: "Ticket Summary", icon: <TrackChangesIcon />, path: "/user-roles/ticket-summary", disabled: false },
  ...(isBottlerAdminEnabled ? [
    { id: "bottler-onboarding", name: "Bottler Onboarding", icon: <PersonIcon />, path: "/bottler-admin/elm-access", disabled: false, requiredRole: SOP_KO_BOTTLER_ADMIN_ROLE },
    { id: "domain-whitelist", name: "Domain Whitelist", icon: <DomainVerificationIcon />, path: "/bottler-admin/domain-whitelist", disabled: false, requiredRole: SOP_KO_BOTTLER_ADMIN_ROLE },
  ] : []),
  { id: "approver-config", name: "Approver Configuration", icon: <TuneIcon />, path: "/user-roles/admin-portal", disabled: false, adminOnly: false },
  { id: "access-control", name: "Admin Portal", icon: <AdminPanelSettingsIcon />, path: "/user-roles/access-control", disabled: false, adminOnly: true }
];
